"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTimer = void 0;
const react_1 = require("react");
const duration_1 = __importDefault(require("dayjs/plugin/duration"));
const dayjs_1 = require("../utils/dayjs");
const useInterval_1 = require("./useInterval");
dayjs_1.dayjsCore.extend(duration_1.default);
const useTimer = ({ name, value, formatValue = 's', formatResult = 's', }) => {
    let storageItem = null;
    if (typeof window !== 'undefined') {
        storageItem = sessionStorage.getItem(name);
    }
    const initSeconds = storageItem
        ? (0, dayjs_1.dayjsCore)(+storageItem).diff((0, dayjs_1.dayjsCore)(), formatValue)
        : dayjs_1.dayjsCore.duration(value, formatValue).asSeconds(); // TODO resolve for ms
    const [delay, setDelay] = (0, react_1.useState)(1000);
    const [seconds, setSeconds] = (0, react_1.useState)(initSeconds);
    const restart = (0, react_1.useCallback)(() => {
        setDelay(1000);
        setSeconds(initSeconds);
    }, [initSeconds]);
    const reset = (0, react_1.useCallback)(() => {
        setDelay(null);
        setSeconds(null);
        localStorage.removeItem(name);
    }, [name]);
    const timer = (0, react_1.useCallback)(() => {
        let diffTime;
        const storageDate = sessionStorage.getItem(name);
        if (!storageDate) {
            const newTime = (0, dayjs_1.dayjsCore)().add(value, formatValue);
            sessionStorage.setItem(name, `${newTime.valueOf()}`);
            diffTime = newTime.diff((0, dayjs_1.dayjsCore)(), formatValue);
        }
        else {
            diffTime = (0, dayjs_1.dayjsCore)(+storageDate).diff((0, dayjs_1.dayjsCore)(), formatValue);
        }
        if (diffTime > 0) {
            setSeconds(diffTime);
        }
        else {
            sessionStorage.setItem(name, '');
            setSeconds(null);
            setDelay(null);
        }
    }, [formatValue, name, value]);
    (0, useInterval_1.useIntervalForTimer)(timer, delay);
    return {
        timer: seconds ? dayjs_1.dayjsCore.duration(seconds * 1000).format(formatResult) : null,
        isTimerFinish: !delay,
        restart,
        reset,
    };
};
exports.useTimer = useTimer;
//# sourceMappingURL=useTimer.js.map